export const injuryReportPanelClassName =
	'rounded-2xl border border-gray-200 border-opacity-80 dark:border-dark-border bg-white bg-opacity-90 dark:bg-dark-card shadow-sm backdrop-blur-sm';

/** Contrasts with page (dark-bg) and card body (dark-card), matches other index tables. */
export const injuryReportTableHeadBgClassName = 'bg-gray-100 dark:bg-gray-800';

export const injuryReportTableHeadClassName =
	'text-xs font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400';

export const injuryReportTableHeadRowClassName = `border-b border-gray-200 dark:border-dark-border ${injuryReportTableHeadBgClassName}`;

export const injuryReportRowBgClassName = 'bg-white dark:bg-dark-card';

export const injuryReportRowHoverClassName = `group border-b border-gray-100 dark:border-dark-border transition-colors ${injuryReportRowBgClassName} hover:bg-gray-50 dark:hover:bg-gray-800`;

/** Sticky player cell: same solid hover as row (opacity hover blends differently on opaque cells). */
export const injuryReportStickyPlayerCellClassName = `sticky left-0 z-10 transition-colors ${injuryReportRowBgClassName} group-hover:bg-gray-50 dark:group-hover:bg-gray-800`;

export function getTeamDisplayName(team) {
	if (!team || !team.name) return 'Free Agent';
	return team.name.split(' ').slice(-1)[0];
}
